import { memo, useMemo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Typography from 'components/UI/Typography/Typography';

import CoinIcon from 'images/RewardSystem/coin.png';

import styles from './ProgressBar.module.scss';

const percentageBreakpoints = [0, 50, 100];

const ProgressBar = ({ value = 0 }) => {
  const filled = value >= percentageBreakpoints[2];

  const percentageValues = useMemo(
    () =>
      percentageBreakpoints.map((value) => (
        <Typography
          key={value}
          type="text-xs"
          color="grey"
          className={styles.barPercentageValue}
        >
          {value}%
        </Typography>
      )),
    [],
  );

  return (
    <div className={styles.root}>
      <div className={styles.coinWrapper}>
        <img src={CoinIcon} alt="coin icon" className={styles.coinIcon} />
      </div>
      <div className={styles.barWrapper}>
        <Typography type="text-sm" weight="semibold">
          Complete all marketing activities
        </Typography>
        <div className={styles.bar}>
          <div className={styles.barProgress}>
            <div
              className={classNames(styles.barValue, {
                [styles.filled]: filled,
              })}
              style={{ width: `${value}%` }}
            />
            <div
              className={classNames(styles.barArrow, {
                [styles.active]: value >= percentageBreakpoints[1],
                [styles.filled]: filled,
              })}
            />
          </div>
          <div className={styles.barPercentage}>{percentageValues}</div>
        </div>
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
};

export default memo(ProgressBar);
